import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getColor } from '../../system';
import styles from './index.module.css';
const SYSTEM_PROPS = ['marginProps', 'floatProps'];
const Divider = /*#__PURE__*/function () {
  const Divider = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      color,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);

    // Map color to borderColor (color from the system would return {color: color}, we want {borderColor: color})
    const [, borderColor] = getColor(color);
    return /*#__PURE__*/React.createElement("hr", _extends({
      className: cx(styles.root, className),
      style: {
        ...style,
        borderColor
      },
      ref: ref
    }, rest));
  });
  Divider.displayName = 'Divider';
  Divider.identifier = Divider.displayName;
  Divider.clonableProps = SYSTEM_PROPS;
  Divider.defaultProps = {
    m: 0
  };
  return Divider;
}();
export default Divider;